import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import LinkButton from '../../../../../components/LinkButton';
import ENDPOINT from '../../../../../constants/endpoints';
import FileHelper from '../../../../../helpers/file';
import useApi from '../../../../../hooks/useApi';
import ResponseErrorDialog from '../../ResponseErrorDialog';

const FollowUpEmailTemplateViewDialogBody = props => {
  const { ID, Name, Subject, Message, attachments } = props;

  const api = useApi();

  const handleDownloadAttach = attachId => {
    api.download(
      ENDPOINT.ACTION.EMAIL_TEMPLATE_FOLLOWUP.DOWNLOAD_ATTACH,
      { id: ID, attachId },
      {
        handleError: response => ResponseErrorDialog({ response }),
        handleSuccess: response => {
          FileHelper.downloadInit(response.file, response.filename);
        },
      }
    );
  };

  return (
    <div className="follow-up-email-template-view-dialog-body">
      <div className="follow-up-email-template-view-dialog-body__row">
        <span style={{ marginRight: '0.5em' }}>Name:</span>
        <div className="follow-up-email-template-view-dialog-body__name">
          {Name}
        </div>
      </div>
      <div className="follow-up-email-template-view-dialog-body__row">
        <span style={{ marginRight: '0.5em' }}>Subject:</span>
        <div className="follow-up-email-template-view-dialog-body__subject">
          {Subject}
        </div>
      </div>
      <div className="follow-up-email-template-view-dialog-body__text">
        <p
          className="follow-up-email-template-view-dialog-body__message"
          dangerouslySetInnerHTML={{ __html: Message }}
        />
      </div>
      {attachments && attachments.length > 0 && (
        <div className="follow-up-email-template-view-dialog-body__attachments">
          <div className="follow-up-email-template-view-dialog-body__attachments-list">
            Attachments:
            {attachments.map(a => (
              <div
                key={a.id}
                className="follow-up-email-template-view-dialog-body__attachment"
              >
                <LinkButton
                  btnStyles={{
                    fontSize: '0.8571rem',
                    fontWeight: 400,
                  }}
                  text={a.name}
                  controlFunc={() => handleDownloadAttach(a.id)}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

FollowUpEmailTemplateViewDialogBody.propTypes = {
  ID: PropTypes.string,
  Name: PropTypes.string,
  Subject: PropTypes.string,
  Message: PropTypes.string,
  attachments: PropTypes.array,
};

export default FollowUpEmailTemplateViewDialogBody;
